import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from './sidebar';
import Loader from '../global-components/loader';

const NewsList = () => {
	const [news, setnews] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [currentPage, setCurrentPage] = useState(1);
	const newsPerPage = 5; // Number of news per page
	useEffect(() => {
		const fetchnews = async () => {
			try {
				const response = await fetch('https://khapa.tagit.pk/api/blog.php?news=All');
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				const data = await response.json();
				setnews(data);
			} catch (error) {
				setError(error.message);
			} finally {
				setLoading(false);
			}
		};

		fetchnews();
	}, []);

	let publicUrl = process.env.PUBLIC_URL + '/';
	let imageFetchPath = 'https://khapa.tagit.pk/public/img/';

	// Helper function to truncate content to 100 words
	const truncateContent = (content) => {
		return content.split(' ').slice(0, 100).join(' ') + '...';
	};

	// Pagination calculations
	const indexOfLastnews = currentPage * newsPerPage;
	const indexOfFirstnews = indexOfLastnews - newsPerPage;
	const currentnews = news.slice(indexOfFirstnews, indexOfLastnews);
	const totalPages = Math.ceil(news.length / newsPerPage);

	// Pagination calculations
	const maxVisibleLinks = 10; // Maximum number of visible page links
	const halfMaxLinks = Math.floor(maxVisibleLinks / 2);

	const generatePagination = () => {
		let pagination = [];
		const startPage = Math.max(1, currentPage - halfMaxLinks);
		const endPage = Math.min(startPage + maxVisibleLinks - 1, totalPages);

		// Add the first page and ellipsis if necessary
		if (startPage > 1) {
			pagination.push(1);
			if (startPage > 2) pagination.push("...");
		}

		// Add the visible range of page numbers
		for (let i = startPage; i <= endPage; i++) {
			pagination.push(i);
		}

		// Add ellipsis and the last page if necessary
		if (endPage < totalPages) {
			if (endPage < totalPages - 1) pagination.push("...");
			pagination.push(totalPages);
		}

		return pagination;
	};

	const pagination = generatePagination();


	const handlePageChange = (pageNumber) => {
		setCurrentPage(pageNumber);
		window.scrollTo({
			top: 0,
			behavior: 'smooth', // Optional for a smooth scroll effect
		});
	};
	

	if (loading) {
        return <Loader />;
    }


	if (error) {
		return <p>Error: {error}</p>;
	}

	return (
		<div className="blog-page-area pd-bottom-80 go-top">
			<div className="container">
				<div className="row">
					<div className="col-lg-9 pd-top-50">
						{currentnews.map((news) => (
							<div key={news.id} className="single-blog-inner">
								<div className="thumb">
									<img
										src={
											news.post_image
												? news.post_image
												: `${publicUrl}assets/img/blog/4.png`
										}
										alt={news.title || 'news image'}
										onError={(e) => {
											e.target.onerror = null; // Prevents infinite loop in case default image fails
											e.target.src = `${publicUrl}assets/img/blog/4.png`; // Set default image
										  }}
									/>
								</div>
								<div className="single-blog-details">
									<div className="meta">
										<span className="author">
											<i className="fa fa-user" />
											{news.author || 'Unknown'}
										</span>
										<span className="date">
											<i className="fa fa-calendar" />
											{new Date(news.created_at).toLocaleDateString()}
										</span>
										<span className="comments">
											<i className="fa fa-folder" />
											{news.category || 'N/A'}
										</span>
									</div>
									<h3>
										<Link to={{
											pathname: `/news-details/${news.id}`, // Existing route with news ID
											state: { news } // Passing the news data as state
										}}>{news.title}</Link>
									</h3>
									<Link
										className="btn btn-base"
										to={{
											pathname: `/news-details/${news.id}`, // Existing route with news ID
											state: { news } // Passing the news data as state
										}}
									>
										Learn More
									</Link>

								</div>
							</div>
						))}

						{/* Pagination */}
						<nav className="mt-4">
							<ul className="pagination">
								<li className={`page-item prev ${currentPage === 1 ? 'disabled' : ''}`}>
									<button
										className="page-link"
										onClick={() => handlePageChange(currentPage - 1)}
										disabled={currentPage === 1}
									>
										<i className="fa fa-angle-left" />
									</button>
								</li>
								{pagination.map((item, index) => (
									<li
										key={index}
										className={`page-item ${item === currentPage ? 'active' : ''} ${item === "..." ? "disabled" : ""
											}`}
									>
										{item === "..." ? (
											<span className="page-link">{item}</span>
										) : (
											<button className="page-link" onClick={() => handlePageChange(item)}>
												{item}
											</button>
										)}
									</li>
								))}
								<li className={`page-item next ${currentPage === totalPages ? 'disabled' : ''}`}>
									<button
										className="page-link"
										onClick={() => handlePageChange(currentPage + 1)}
										disabled={currentPage === totalPages}
									>
										<i className="fa fa-angle-right" />
									</button>
								</li>
							</ul>
						</nav>
					</div>
					<Sidebar />
				</div>
			</div>
		</div>
	);
};

export default NewsList;
